import { createAction } from '@ngrx/store';

export const updateListsAfterScanToListDestroy = createAction(
  '[Scanner] Update lists after scan to list destroy',
);
